import { createTheme } from '@mui/material/styles';
import { tokens } from '@torlin/design-tokens';

const theme = createTheme({
  cssVariables: {
    colorSchemeSelector: 'data-mui-color-scheme',
  },
  colorSchemes: {
    light: {
      palette: {
        primary: { main: tokens.color.primary, dark: tokens.color.primaryDark },
        secondary: { main: tokens.color.accent },
        background: { default: tokens.color.background, paper: tokens.color.surface },
        text: { primary: tokens.color.text, secondary: tokens.color.textMuted },
        divider: '#DCE5F0',
      },
    },
    dark: {
      palette: {
        primary: { main: tokens.color.primary, dark: tokens.color.primaryDark },
        secondary: { main: tokens.color.accent },
        background: { default: '#070C11', paper: '#111A23' },
        text: { primary: '#F4F7FA', secondary: '#9EACBB' },
        divider: '#263442',
      },
    },
  },
  shape: { borderRadius: tokens.radius.md },
  typography: {
    fontFamily: 'Roboto, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    h1: { fontFamily: 'Rubik, Roboto, ui-sans-serif, system-ui, sans-serif', fontWeight: 500, letterSpacing: '-0.04em' },
    h2: { fontFamily: 'Rubik, Roboto, ui-sans-serif, system-ui, sans-serif', fontWeight: 500, letterSpacing: '-0.035em' },
    h3: { fontFamily: 'Rubik, Roboto, ui-sans-serif, system-ui, sans-serif', fontWeight: 500, letterSpacing: '-0.025em' },
  },
  components: {
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: { root: { textTransform: 'none', fontWeight: 700, borderRadius: 10 } },
    },
    MuiCard: {
      styleOverrides: {
        root: ({ theme: currentTheme }) => ({
          boxShadow: '0 18px 60px rgba(28, 32, 38, 0.08)',
          ...currentTheme.applyStyles('dark', { boxShadow: '0 18px 60px rgba(0, 0, 0, 0.28)' }),
        }),
      },
    },
  },
});

export default theme;
